<template>
    <section id="benifits" class="section benifits-area">
        <div class="container">
            <div class="row">
                <!-- Benifits Item -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                    <div class="benifits-item text-center">
                        <div class="feature-icon">
                            <img src="assets/img/gift.svg" alt="">
                        </div>
                        <!-- Benifits Text -->
                        <div class="benifits-text">
                            <h3 class="mb-2">{{ $t('promo.freeTitle') }}</h3>
                            <p>{{ $t('promo.freeDesc') }}</p>
                        </div>
                    </div>
                </div>
                <!-- Benifits Item -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                    <div class="benifits-item text-center">
                        <div class="feature-icon">
                            <img src="assets/img/flash.svg" alt="">
                        </div>
                        <!-- Benifits Text -->
                        <div class="benifits-text">
                            <h3 class="mb-2">{{ $t('promo.easyTitle') }}</h3>
                            <p>{{ $t('promo.easyDesc') }}</p>
                        </div>
                    </div>
                </div>
                <!-- Benifits Item -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                    <div class="benifits-item text-center">
                        <div class="feature-icon">
                            <img src="assets/img/headphones_round.svg" alt="">
                        </div>
                        <!-- Benifits Text -->
                        <div class="benifits-text">
                            <h3 class="mb-2">{{ $t('promo.supportTitle') }}</h3>
                            <p>{{ $t('promo.supportDesc') }}</p>
                        </div>
                    </div>
                </div>
                <!-- Benifits Item -->
                <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                    <div class="benifits-item text-center">
                        <div class="feature-icon">
                            <img src="assets/img/ai.svg" alt="">
                        </div>
                        <!-- Benifits Text -->
                        <div class="benifits-text">
                            <h3 class="mb-2">{{ $t('promo.smartTitle') }}</h3>
                            <p>{{ $t('promo.smartDesc') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {

}
</script>

<style scoped>
.benifits-area {
    background: #fff;
    padding: 78px 0 92px;
}

.benifits-item {
    background: #f7fbff;
    border-radius: 8px;
    min-height: 220px;
    padding: 34px 24px;
    position: relative;
}

.feature-icon {
    align-items: center;
    background: var(--blue);
    border-radius: 8px;
    display: inline-flex;
    height: 58px;
    justify-content: center;
    margin-bottom: 24px;
    width: 58px;
}

.feature-icon img {
    filter: brightness(0) invert(1);
    max-height: 30px;
    max-width: 30px;
}

.benifits-text h3 {
    color: #0d1c35;
    font-size: 18px;
    font-weight: 800;
}

.benifits-text p {
    color: #63708a;
    font-size: 14px;
    line-height: 1.55;
}

.col-12:nth-child(2) .feature-icon {
    background: #0b937f;
}

.col-12:nth-child(3) .feature-icon {
    background: #79b942;
}

.col-12:nth-child(4) .feature-icon {
    background: #19a7a7;
}

@media (max-width: 991px) {
    .benifits-item {
        margin-bottom: 24px;
    }
}

</style>
